import { WithSequenceStatePropsType } from 'components/hoc/withSequenceState';
import withSequenceState from 'components/hoc/withSequenceState';
import CardDetailProduct from 'components/molecules/Card/Detail/Product';
import { CardDetailPropsType } from 'components/molecules/Card/Fragments/CardDetail';
import Sequences from 'defs/sequences';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators, getDisableRetailerContext, getIsDone, getProductId, getValidRange } from 'store/programItems';
import { RootStateType } from 'store/programItems';

export type StateToPropsType = {
	isDone: ReturnType<typeof getIsDone>;
	productId: ReturnType<typeof getProductId>;
	disableRetailerContext: ReturnType<typeof getDisableRetailerContext>;
	validRange: ReturnType<typeof getValidRange>;
};
export type DispatchToPropsType = typeof actionCreators;

const mapStateToProps = (state: RootStateType, ownProps: CardDetailPropsType): StateToPropsType => ({
	isDone: getIsDone(state, ownProps.id),
	productId: getProductId(state, ownProps.id),
	disableRetailerContext: getDisableRetailerContext(state, ownProps.id),
	validRange: getValidRange(state, ownProps.id),
});

const mapDispatchToProps = (dispatch): DispatchToPropsType => {
	return bindActionCreators(actionCreators, dispatch);
};

export type ContainerCardDetailProductPropsType = CardDetailPropsType &
	StateToPropsType &
	DispatchToPropsType &
	WithSequenceStatePropsType;

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withSequenceState(CardDetailProduct as any, [Sequences.CARD_IS_CHECKING]) as any);
